// extracted by mini-css-extract-plugin
module.exports = {"DeleteServiceCallModal":"DeleteServiceCallModal_DeleteServiceCallModal__1xXwW"};